import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import { useData } from '../../contexts/DataContext';
import { formatZAR } from '../../utils/currency';
import { Link } from 'react-router-dom';
export function PopularProducts() {
  const {
    products,
    orders
  } = useData();
  // Calculate product popularity based on orders
  // This is a simple implementation. In a real app, this would be aggregated on backend
  const productSales = products.map(product => {
    const salesCount = orders.reduce((count, order) => {
      const item = order.items.find(i => i.productId === product.id);
      return count + (item ? item.quantity : 0);
    }, 0);
    return {
      ...product,
      sales: salesCount,
      revenue: salesCount * product.price
    };
  }).sort((a, b) => b.sales - a.sales).slice(0, 3);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.4
  }} className="bg-white rounded-2xl border border-rose-100 shadow-sm p-6" data-id="element-366">
      <div className="flex justify-between items-center mb-6" data-id="element-367">
        <h3 className="text-lg font-bold text-gray-900 font-serif" data-id="element-368">
          Top Sellers
        </h3>
        <button className="p-2 text-rose-500 hover:bg-rose-50 rounded-lg transition-colors" data-id="element-369">
          <TrendingUp size={20} data-id="element-370" />
        </button>
      </div>

      <div className="space-y-6" data-id="element-371">
        {productSales.map((product, index) => <motion.div key={product.id} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5 + index * 0.1
      }} className="flex items-center space-x-4 group cursor-pointer" data-id="element-372">
            <div className="relative w-16 h-16 rounded-xl overflow-hidden" data-id="element-373">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-374" />
            </div>
            <div className="flex-1" data-id="element-375">
              <h4 className="font-medium text-gray-900 group-hover:text-rose-500 transition-colors line-clamp-1" data-id="element-376">
                {product.name}
              </h4>
              <p className="text-sm text-gray-500" data-id="element-377">{product.category}</p>
            </div>
            <div className="text-right" data-id="element-378">
              <p className="font-bold text-gray-900" data-id="element-379">
                {formatZAR(product.revenue)}
              </p>
              <p className="text-xs text-emerald-500 font-medium" data-id="element-380">
                {product.sales} sales
              </p>
            </div>
          </motion.div>)}
      </div>

      <Link to="/admin/products" data-id="element-381">
        <button className="w-full mt-6 py-3 text-sm font-medium text-rose-500 border border-rose-200 rounded-xl hover:bg-rose-50 transition-colors" data-id="element-382">
          View All Products
        </button>
      </Link>
    </motion.div>;
}